import { EventModel } from 'ngx-core-services';

export const  updateEventModelsTranslations = (labels: any) => {
    return {
      [EventModel.WeakBattery]: {
        'translateName': labels.weakBatteryName,
        'translateDescription': labels.weakBatteryDescription,
      },
      [EventModel.BatteryLow]: {
        'translateName': labels.batteryLowName,
        'translateDescription': labels.batteryLowDescription,
      },
      [EventModel.BMS1CommunicatonFault]: {
        'translateName': labels.bms1CommunicatonFaultName,
        'translateDescription': labels.bms1CommunicatonFaultDescription,
      },
      [EventModel.BMS2CommunicatonFault]: {
        'translateName': labels.bms2CommunicatonFaultName,
        'translateDescription': labels.bms2CommunicatonFaultDescription,
      },
      [EventModel.BMSOvervoltageProtection]: {
        'translateName': labels.bmsOvervoltageProtectionName,
        'translateDescription': labels.bmsOvervoltageProtectionDescription,
      },
      [EventModel.BMSUndervoltageProtection]: {
        'translateName': labels.bmsUndervoltageProtectionName,
        'translateDescription': labels.bmsUndervoltageProtectionDescription,
      },
      [EventModel.BMSVerFault]: {
        'translateName': labels.bmsVerFaultName,
        'translateDescription': labels.bmsVerFaultDescription,
      },
      [EventModel.ZBTS5kSleepMode]: {
        'translateName': labels.ZBTS5kSleepModeName,
        'translateDescription': labels.ZBTS5kSleepModeDescription,
      },
      [EventModel.BusHardwareOvervoltageFault]: {
        'translateName': labels.busHardwareOvervoltageFaultName,
        'translateDescription': labels.busHardwareOvervoltageFaultDescription,
      },
      [EventModel.BusOvervoltageFault]: {
        'translateName': labels.busOvervoltageFaultName,
        'translateDescription': labels.busOvervoltageFaultDescription,
      },
      [EventModel.BusUnbalanceFault]: {
        'translateName': labels.busUnbalanceFaultName,
        'translateDescription': labels.busUnbalanceFaultDescription,
      },
      [EventModel.CTError]: {
        'translateName': labels.ctErrorName,
        'translateDescription': labels.ctErrorDescription,
      },
      [EventModel.EpsBatteryOvercurrentFault]: {
        'translateName': labels.epsBatteryOvercurrentFaultName,
        'translateDescription': labels.epsBatteryOvercurrentFaultDescription,
      },
      [EventModel.Fan1Failure]: {
        'translateName': labels.fan1FailureName,
        'translateDescription': labels.fan1FailureDescription,
      },
      [EventModel.Fan2Failure]: {
        'translateName': labels.fan2FailureName,
        'translateDescription': labels.fan2FailureDescription,
      },
      [EventModel.Fan3Failure]: {
        'translateName': labels.fan3FailureName,
        'translateDescription': labels.fan3FailureDescription,
      },
      [EventModel.Fan4Failure]: {
        'translateName': labels.fan4FailureName,
        'translateDescription': labels.fan4FailureDescription,
      },
      [EventModel.Fan5Failure]: {
        'translateName': labels.fan5FailureName,
        'translateDescription': labels.fan5FailureDescription,
      },
      [EventModel.Fan6Failure]: {
        'translateName': labels.fan6FailureName,
        'translateDescription': labels.fan6FailureDescription,
      },
      [EventModel.Fan7Failure]: {
        'translateName': labels.fan7FailureName,
        'translateDescription': labels.fan7FailureDescription,
      },
      [EventModel.GridOverfrequency]: {
        'translateName': labels.gridOverfrequencyName,
        'translateDescription': labels.gridOverfrequencyDescription,
      },
      [EventModel.GridOvervoltage]: {
        'translateName': labels.gridOvervoltageName,
        'translateDescription': labels.gridOvervoltageDescription,
      },
      [EventModel.GridUnderfrequency]: {
        'translateName': labels.gridUnderfrequencyName,
        'translateDescription': labels.gridUnderfrequencyDescription,
      },
      [EventModel.GridUndervoltage]: {
        'translateName': labels.gridUndervoltageName,
        'translateDescription': labels.gridUndervoltageDescription,
      },
      [EventModel.InconsistentSoftwareVersion]: {
        'translateName': labels.inconsistentSoftwareVersionName,
        'translateDescription': labels.inconsistentSoftwareVersionDescription,
      },
      [EventModel.InputModeSettingFailure]: {
        'translateName': labels.inputModeSettingFailureName,
        'translateDescription': labels.inputModeSettingFailureDescription,
      },
      [EventModel.InputOvercurrentFault]: {
        'translateName': labels.inputOvercurrentFaultName,
        'translateDescription': labels.inputOvercurrentFaultDescription,
      },
      [EventModel.InverterSoftStartFailure]: {
        'translateName': labels.inverterSoftStartFailureName,
        'translateDescription': labels.inverterSoftStartFailureDescription,
      },
      [EventModel.IslandingError]: {
        'translateName': labels.islandingErrorName,
        'translateDescription': labels.islandingErrorDescription,
      },
      [EventModel.LeakageCurrentFault]: {
        'translateName': labels.leakageCurrentFaultName,
        'translateDescription': labels.leakageCurrentFaultDescription,
      },
      [EventModel.LowInsulationResistance]: {
        'translateName': labels.lowInsulationResistanceName,
        'translateDescription': labels.lowInsulationResistanceDescription,
      },
      [EventModel.MeterError]: {
        'translateName': labels.meterErrorName,
        'translateDescription': labels.meterErrorDescription,
      },
      [EventModel.OutputInstantaneousOvercurrentFault]: {
        'translateName': labels.outputInstantaneousOvercurrentFaultName,
        'translateDescription': labels.outputInstantaneousOvercurrentFaultDescription,
      },
      [EventModel.PVOvervoltage]: {
        'translateName': labels.pvOvervoltageName,
        'translateDescription': labels.pvOvervoltageDescription,
      },
      [EventModel.PvUnevenCurrentFault]: {
        'translateName': labels.pvUnevenCurrentFaultName,
        'translateDescription': labels.pvUnevenCurrentFaultDescription,
      },
      [EventModel.RelayDetectionFailure]: {
        'translateName': labels.relayDetectionFailureName,
        'translateDescription': labels.relayDetectionFailureDescription,
      },
      [EventModel.RelayUnbalancedPermanentFailure]: {
        'translateName': labels.relayUnbalancedPermanentFailureName,
        'translateDescription': labels.relayUnbalancedPermanentFailureDescription,
      },
      [EventModel.SCIError_AC]: {
        'translateName': labels.sciError_ACName,
        'translateDescription': labels.sciError_ACDescription,
      },
      [EventModel.SCIError_DC]: {
        'translateName': labels.sciError_DCName,
        'translateDescription': labels.sciError_DCDescription,
      },
      [EventModel.SCIError_Fuse]: {
        'translateName': labels.sciError_FuseName,
        'translateDescription': labels.sciError_FuseDescription,
      },
      [EventModel.SPICommError_AC]: {
        'translateName': labels.spiCommError_ACName,
        'translateDescription': labels.spiCommError_ACDescription,
      },
      [EventModel.SPICommError_DC]: {
        'translateName': labels.spiCommError_DCName,
        'translateDescription': labels.spiCommError_DCDescription,
      },
      [EventModel.SafetyVerFault]: {
        'translateName': labels.safetyVerFaultName,
        'translateDescription': labels.safetyVerFaultDescription,
      },
      [EventModel.AcCurrentUnbalanceFault]: {
        'translateName': labels.acCurrentUnbalanceFaultName,
        'translateDescription': labels.acCurrentUnbalanceFaultDescription,
      },
      [EventModel.AcHardwareOvercurrentFault]: {
        'translateName': labels.acHardwareOvercurrentFaultName,
        'translateDescription': labels.acHardwareOvercurrentFaultDescription,
      },
      [EventModel.BatteryLowVoltageShutdown]: {
        'translateName': labels.batteryLowVoltageShutdownName,
        'translateDescription': labels.batteryLowVoltageShutdownDescription,
      },
      [EventModel.GPMError]: {
        'translateName': labels.gpmErrorName,
        'translateDescription': labels.gpmErrorDescription,
      },
      [EventModel.GPMNotice]: {
        'translateName': labels.gpmNoticeName,
        'translateDescription': labels.gpmNoticeDescription,
      },
      [EventModel.GPMWarning]: {
        'translateName': labels.gpmWarningName,
        'translateDescription': labels.gpmWarningDescription,
      },
    };
  }
